import { render, staticRenderFns } from "./alarm-panel-item.vue?vue&type=template&id=8788bf40&scoped=true&"
import script from "./alarm-panel-item.vue?vue&type=script&lang=js&"
export * from "./alarm-panel-item.vue?vue&type=script&lang=js&"
import style0 from "./alarm-panel-item.vue?vue&type=style&index=0&id=8788bf40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8788bf40",
  null
  
)

export default component.exports